/* ==========================================================
   NURÉVE — Rechtstexte
   1) fremdes Design im Textkörper entfernen
   2) Nummerierung der Überschriften erkennen und golden setzen
   3) Inhaltsverzeichnis bauen (H2 = Hauptpunkt, H3 = Unterpunkt)
   4) Widerrufsformular als Karte, Ausfüll-Linien, Kanzlei-Vermerk,
      Inhaltsverzeichnis im Text als verlinkte Karte
      (nur Darstellung – kein Wort des Textes wird verändert)
   ========================================================== */
(function () {
  var UMLAUT = { 'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'ß': 'ss' };
  var NUM_RE = /^\s*((?:§\s*)?\d+(?:\.\d+)*|[IVXLC]+)[.)\]]?\s+(.*)$/;

  function slug(text, i) {
    var base = (text || '').toLowerCase()
      .replace(/[äöüß]/g, function (c) { return UMLAUT[c]; })
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return (base || 'abschnitt') + '-' + i;
  }

  function norm(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9äöüß]/g, '');
  }

  function split(text) {
    var m = (text || '').match(NUM_RE);
    if (!m) return null;
    return { num: m[1].replace(/\s+/g, ' ').trim(), label: m[2].trim() };
  }

  function clean(prose) {
    Array.prototype.forEach.call(prose.querySelectorAll('style, link, script'), function (el) {
      el.parentNode.removeChild(el);
    });
    Array.prototype.forEach.call(prose.querySelectorAll('[style]'), function (el) {
      el.removeAttribute('style');
    });
    Array.prototype.forEach.call(prose.querySelectorAll('[class]'), function (el) {
      el.removeAttribute('class');
    });
    Array.prototype.forEach.call(prose.querySelectorAll('font'), function (el) {
      var parent = el.parentNode;
      while (el.firstChild) parent.insertBefore(el.firstChild, el);
      parent.removeChild(el);
    });

    var title = document.querySelector('.nrvl-h1');
    var h1 = prose.querySelector('h1');
    if (title && h1 && norm(h1.textContent) === norm(title.textContent)) {
      h1.parentNode.removeChild(h1);
    }
  }

  /* ---------- Darstellung: Formular-Karte, Linien, Vermerk, Index ---------- */
  function enhance(prose) {
    Array.prototype.forEach.call(prose.querySelectorAll('h2'), function (h) {
      var txt = h.textContent || '';

      // Inhaltsverzeichnis im Text: nicht in die Seitenleiste, Liste als Karte
      if (/^\s*inhaltsverzeichnis\s*$/i.test(txt)) {
        h.setAttribute('data-nrvl-skip', '');
        var list = h.nextElementSibling;
        if (list && list.tagName === 'OL') list.className = 'nrvl-index';
        return;
      }

      // Abschnitt "Widerrufsformular" in eine Karte fassen
      if (!/widerrufsformular/i.test(txt)) return;
      var group = [];
      var n = h.nextElementSibling;
      while (n && !/^H[12]$/.test(n.tagName)) { group.push(n); n = n.nextElementSibling; }
      if (!group.length) return;
      var card = document.createElement('div');
      card.className = 'nrvl-card';
      h.parentNode.insertBefore(card, group[0]);
      group.forEach(function (el) { card.appendChild(el); });
    });

    // Ausfüll-Linien (Unterstriche) als feine Linien darstellen
    var walker = document.createTreeWalker(prose, NodeFilter.SHOW_TEXT, null, false);
    var hits = [];
    while (walker.nextNode()) {
      if (/_{5,}/.test(walker.currentNode.nodeValue)) hits.push(walker.currentNode);
    }
    hits.forEach(function (node) {
      var parts = node.nodeValue.split(/(_{5,})/);
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (/^_{5,}$/.test(part)) {
          var s = document.createElement('span');
          s.className = 'nrvl-fill';
          s.textContent = part;
          frag.appendChild(s);
        } else {
          frag.appendChild(document.createTextNode(part));
        }
      });
      node.parentNode.replaceChild(frag, node);
    });

    // Absatz-Ziffern (z. B. 1.1) golden setzen
    Array.prototype.forEach.call(prose.querySelectorAll('p > b:first-child, p > strong:first-child'), function (b) {
      if (b.previousSibling && /\S/.test(b.previousSibling.nodeValue || '')) return;
      if (/^\s*\d+(\.\d+)*\s*$/.test(b.textContent || '')) b.className = 'nrvl-pnum';
    });

    // Copyright-Vermerk der IT-Recht Kanzlei
    var credit = prose.querySelector('#itkanzlei_txt_copyright');
    if (credit) credit.className = 'nrvl-credit';
  }

  // Einträge des Inhaltsverzeichnisses mit den Abschnitten verlinken (Text bleibt gleich)
  function linkIndex(prose) {
    var list = prose.querySelector('ol.nrvl-index');
    if (!list) return;
    var heads = prose.querySelectorAll('h2[id]');
    Array.prototype.forEach.call(list.children, function (li) {
      var key = norm(li.textContent);
      for (var i = 0; i < heads.length; i++) {
        var numEl = heads[i].querySelector('.nrvl-num');
        var label = heads[i].textContent;
        if (numEl) label = label.replace(numEl.textContent, '');
        if (norm(label) === key) {
          var a = document.createElement('a');
          a.href = '#' + heads[i].id;
          while (li.firstChild) a.appendChild(li.firstChild);
          li.appendChild(a);
          break;
        }
      }
    });
  }

  function build(prose, box) {
    var heads = prose.querySelectorAll('h1, h2, h3');
    if (!heads.length) return;

    var list = document.createElement('ol');
    var items = [];
    var main = 0;
    var sub = 0;

    Array.prototype.forEach.call(heads, function (h, i) {
      if (h.hasAttribute('data-nrvl-skip')) return;
      var raw = (h.textContent || '').trim();
      if (!raw) return;

      var isSub = h.tagName === 'H3';
      var parts = split(raw);
      var num;

      if (parts) {
        num = parts.num;
        h.textContent = '';
        var tag = document.createElement('span');
        tag.className = 'nrvl-num';
        tag.textContent = num;
        h.appendChild(tag);
        h.appendChild(document.createTextNode(parts.label));
        if (!isSub) { main = parseInt(num.replace(/\D/g, ''), 10) || main + 1; sub = 0; }
      } else {
        if (isSub) { sub += 1; num = (main || 1) + '.' + sub; }
        else { main += 1; sub = 0; num = main + '.'; }
      }

      if (!h.id) h.id = slug(parts ? parts.label : raw, i + 1);

      var li = document.createElement('li');
      if (isSub) li.className = 'is-sub';
      var a = document.createElement('a');
      a.href = '#' + h.id;
      var n = document.createElement('span');
      n.className = 'nrvl-toc-num';
      n.textContent = num.replace(/\.$/, '');
      var t = document.createElement('span');
      t.className = 'nrvl-toc-txt';
      t.textContent = parts ? parts.label : raw;
      a.appendChild(n);
      a.appendChild(t);
      li.appendChild(a);
      list.appendChild(li);
      items.push({ link: a, head: h });
    });

    if (items.length < 3) return;
    box.appendChild(list);
    box.hidden = false;

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        items.forEach(function (it) {
          it.link.classList.toggle('is-current', it.head === entry.target);
        });
      });
    }, { rootMargin: '-14% 0px -70% 0px', threshold: 0 });
    items.forEach(function (it) { io.observe(it.head); });
  }

  function init() {
    var prose = document.querySelector('[data-nrvl-prose]');
    if (!prose) return;
    clean(prose);
    enhance(prose);
    var box = document.querySelector('[data-nrvl-toc]');
    if (box) build(prose, box);
    linkIndex(prose);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
